import React, { Component } from 'react'
import {
  Modal,
  ModalBody,
  UncontrolledAlert,
  Container,
  Row,
  Form,
  FormGroup,
  Label,
  Alert,
  Input,
  Button,
  InputGroup,
  FormFeedback,
  InputGroupAddon,
} from 'reactstrap'
import trivvyLogo from '../../assets/trivvy/trivvy-logo-img.png'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { isMobile, isChrome, isSafari } from '../../utils/deviceInfo'
import If from '../../components/Shared/If'
import axios from '../../axios'
import * as actionCreators from '../../modules/actions/index'
import './Login.css'
import './loginForm.css'
import { validateEmail, validatePassword } from './../../utils/validations'
import {
  navigate_user_to_module,
  oktaImg,
  oktaLogo,
  Spinner,
  return_sso_url,
  loginImg,
  isTrivvyUrl,
  isTrivvyProduct,
  loginImgTrivvy,
} from './../../utils/constants'
import Logo from '../../components/Logo/Logo'
import OOLogo from '../../assets/OOLogo.svg'
import DaniLogo from './../../images/Dani.svg'
import { BiHide, BiShow } from 'react-icons/bi'
import companyLogo from './../../assets/oo_mobile_logo.png'
import LoginSide from '../../components/LoginSide/LoginSide'
import { logger } from '../../utils/logger'
import * as url from '../../utils/url'
import {
  saveToken,
  saveShowInstructions,
  retrieveShowInstructions,
} from '../../utils/localStorage'
import drillDownClose from '../../assets/drilldown_close.svg'
import installInstructionsImage from './../../assets/placeholders/ios_install_instructions.png'
import exportIcon from './../../assets/export.svg'
import { toastContainer } from '../../utils/toast'
// import mixpanel from 'mixpanel-browser';
import RegistrationForm from './RegistrationForm'
import { type } from 'jquery'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: {
        value: '',
        error: false,
      },

      isDisabled: false,
      isShowOptIn: false,
      foundOrg: false,
      findOrg: false,
      isOptIn: false,
      submittedEmail: '',
      showPassword: false,
      orgEmail: {
        value: '',
        error: false,
      },
      isLogin: false,
      alert_org_email_msg: '',
      password: {
        value: '',
        error: false,
      },
      infoModel: !window.navigator.standalone && retrieveShowInstructions(), // Is app installed
      errorMessage: null,
      isFromResetLink: false,
      ssoDisplay: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log('NextPRopss---',nextProps)
    // valid.logged_in_user_check(this.props, nextProps)

    if (nextProps.isAuthenticated) {
      let { profile } = nextProps.user
      let { isSSO, orgAdmin, role, officeId, organizationId } = profile
      let {
        isSetupSkipped,
        isAnalytics,
        isPlanSubscribed,
        planType,
      } = organizationId
      console.log('next--- ', nextProps)
      if (isSSO != true) {
        if (
          organizationId.isSignedUpFromTrivvyWebsite &&
          planType != '001' &&
          !isPlanSubscribed
        ) {
          this.props.history.replace('/subscribe-plan')
          return
        }
        if (!nextProps.isPasswordChanged && isSSO != true) {
          this.props.history.replace('/change-password')
        } else if (
          !organizationId.isOrgConfigured &&
          isSetupSkipped != true &&
          orgAdmin &&
          isAnalytics.status
        ) {
          //orgnization is not configured. Take him to organisation setup.
          const { staticHierarchy } = nextProps.user.profile.organizationId
          // if org-chart setup is complete. check for other incomplete steps
          if (staticHierarchy) {
            axios
              .get(url.getExistingMappings(organizationId._id))
              .then(({ data }) => {
                const payload = data.data.mapping
                const {
                  orgAdmin,
                  isPasswordChanged,
                  skippedSetup,
                  hideCreateTrivvyModal,
                } = nextProps.user.profile
                const { position, performance, separation } = skippedSetup
                if (position && !performance) {
                  this.props.history.replace('/setup/map-performance')
                } else if (position && performance && !separation) {
                  this.props.history.replace('/setup/map-separation')
                } else if (position && performance && separation) {
                  // if(organizationId.isSignedUpFromTrivvyWebsite){

                  if (isTrivvyUrl(organizationId)) {
                    let url = `/home/trivia/${organizationId._id}/list`
                    this.props.history.push(url)
                  } else {
                    // let url = navigate_user_to_module(organizationId);
                    // this.props.history.push(url);
                    let url = `/home/trivia/${organizationId._id}/list`
                    this.props.history.push(url)
                  }
                } else {
                  //if none are skipped, go with the usual flow
                  if (payload.gender.data.length === 0) {
                    this.props.history.replace('/setup/map-gender')
                  } else if (payload.occupation.data.length === 0) {
                    this.props.history.replace('/setup/map-positions')
                  } else if (payload.seniority.data.length === 0) {
                    this.props.history.replace('/setup/map-positions')
                  } else if (payload.performance.data.length === 0) {
                    this.props.history.replace('/setup/map-performance')
                  } else if (payload.separation.data.length === 0) {
                    this.props.history.replace('/setup/map-separation')
                  } else {
                    this.props.history.replace('/setup/welcome')
                  }
                }
              })
              .catch((error) => {
                this.props.history.replace('/setup/map-gender')
              })
            this.props.history.replace('/setup/welcome')
          } else {
            this.props.history.replace('/setup/welcome')
          }
        } else if (!nextProps.isProfileDetailsUpdated) {
          this.props.history.replace('/setup/welcome')
        } else if (
          nextProps.isProfileDetailsUpdated &&
          (nextProps.isPasswordChanged || isSSO == true)
        ) {
          // if(organizationId.isSignedUpFromTrivvyWebsite){
          if (isTrivvyUrl(organizationId)) {
            if (!nextProps.user.profile.hideCreateTrivvyModal) {
              this.props.setCreateModalState(true)
            } else {
              this.props.setCreateModalState(false)
            }
            let url = `/home/trivia/${organizationId._id}/list`
            this.props.history.push(url)
          } else {
            let url = navigate_user_to_module(organizationId)
            this.props.history.push(url)
          }
        }
      }
    }
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.setState({ isDisabled: true })
      this.handleSignIn()
    }
  }

  handleEmailChange = ({ target }) => {
    const { value } = target
    const { email } = this.state
    email.value = value
    email.error = false
    this.setState({
      email,
    })
  }

  orgEmailChange = ({ target }) => {
    const { value } = target
    let { orgEmail } = this.state
    orgEmail.value = value
    // email.error = false;
    this.setState({
      orgEmail,
    })
  }

  handlePasswordChange = ({ target }) => {
    const { value } = target
    const { password } = this.state
    password.value = value
    password.error = false
    this.setState({
      password,
    })
  }

  handleSignIn = () => {
    this.setState({ isDisabled: true })
    const emailValue = this.state.email.value
    const password = this.state.password.value
    const isValidEmail = validateEmail(emailValue)
    const isValidPassword = validatePassword(password)
    // console.log(isValidPassword);
    if (!isValidEmail) {
      this.setState({
        email: {
          value: emailValue,
          error: !isValidEmail,
        },
        isDisabled: false,
      })
    }
    if (!isValidPassword) {
      this.setState({
        password: {
          value: password,
          error: !isValidPassword,
        },
        isDisabled: false,
      })
    }
    if (isValidEmail && isValidPassword) {
      let payload = {
        email: emailValue.toLowerCase(),
        password: password,
      }

      axios
        .post(url.loginUser, payload, {
          headers: {
            Authorization: 'Bearer basicauth',
          },
        })
        .then((response) => { 
          const {data}=response

          const isMFAEnabled=data&&data.userDetails&&data.userDetails.organizationId.mfa.isEnabled
          const hasMobile = !!(data&&data.userDetails.mobileNumber)
          const isAdmin=data&&data.userDetails.role==='Admin'
          
         
            if (!hasMobile&&isMFAEnabled&&isAdmin) {
              const {userDetails}=response.data
                localStorage.setItem(
                  "mfaContext",
                  JSON.stringify({ email:userDetails.email })
                );
             this.props.setCreateModalState(false);
             this.props.history.push("/verify-mobile");
             return; 
              }
           if (hasMobile&&isMFAEnabled&&isAdmin) {
              const {email}=response.data
              localStorage.setItem("mfaContext",JSON.stringify({ email }));
              this.props.setCreateModalState(false);
              this.props.history.push("/two-factor-authentication");
              toastContainer("OTP sent to your number",'success')
           return; 
           }
          saveToken(response.data.autherizationToken)
          this.setState({ isDisabled: false })
          if (
            !response.data.userDetails.hideCreateTrivvyModal &&
            response.data.userDetails.role == 'Admin'
          ) {
            this.props.setCreateModalState(true)
          } else {
            this.props.setCreateModalState(false)
          }
          this.props.onLoginSuccess({
            ...response.data.userDetails,
            autherizationToken: response.data.autherizationToken,
          })
        })
        .catch((error) => {
          console.log('err---------', error)
          if (
            error.response &&
            error.response.data &&
            typeof error.response.data === 'string'
          ) {
            console.log('error.response.data  ---', error.response.data)
            this.setState({ ...this.state, errorMessage: error.response.data })
          } else {
            this.setState({
              ...this.state,
              errorMessage: 'Unable to reach server.',
            })
          }
          this.setState({ isDisabled: false })
        })
    }
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
    var results = regex.exec(this.props.location.search)
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '))
  }

  componentWillMount() {
    // const params = new URLSearchParams(this.props.location.search);
    // const path = params.get('path');
    const path = this.getUrlParameter('path')

    if (path && path !== '') {
      this.setState({ redirectionPath: path })
    }
  }

  componentDidMount() {
    // this.props.onLogoutSuccess();
    // console.log(this.props.history)
    if (this.props.history.location.state) {
      const { isFromResetLink, isLogin } = this.props.history.location.state
      // console.log(isFromResetLink, isLogin)
      this.setState({
        isFromResetLink: isFromResetLink,
        isLogin,
        // foundOrg: this.props.history.location.state.foundOrg
      })
    }

    const params = new URLSearchParams(window.location.search)

    console.log(params.get('orgSignup'))
    if (params.get('orgSignup') == 'true' || params.get('orgSignup') == true) {
      this.setState({
        findOrg: true,
      })
    }
  }

  findOrg = () => {
    this.setState((prevState) => ({
      findOrg: !prevState.findOrg,
      orgEmail: { value: '', error: false },
      isOptIn: false,
      errorMessage: null,
    }))
  }

  handleOrgEmail = (login_type) => {
    let { orgEmail } = this.state
    // console.log(orgEmail)
    let emailVal = orgEmail.value
    // const emailValue = this.state.email.value;
    const isValidEmail = validateEmail(emailVal)

    if (!isValidEmail) {
      this.setState({
        orgEmail: {
          value: emailVal,
          error: !isValidEmail,
        },
      })
    }

    if (isValidEmail) {
      // console.log("clear!")
      let domainSub = emailVal.split('@')[1]
      let domainIdx = domainSub.indexOf('.')
      // let domain = domainSub.slice(0, domainIdx)
      // console.log(domainSub, '----', emailVal)
      let payload = { emailVal, domain: domainSub, login_type }
      // console.log('--pay--',payload)
      axios
        .post(url.checkOrgEmail, payload, {
          headers: {
            Authorization: 'Bearer basicauth',
          },
        })
        .then((response) => {
          this.setState({
            isOptIn: true,
            alert_org_email_msg: `Please check email, ${emailVal}, for instructions.`,
            submittedEmail: emailVal,
            // orgEmail: {value:'', error:false}
          })

          if (login_type == 'sso') {
            const hostname = window.location.hostname

            let { appUrl } = response.data.data[0],
              url_type,
              sso_url

            if (!appUrl || appUrl == undefined || appUrl == null) {
              appUrl = response.data.data[0].appURL
            }

            console.log(appUrl, '---resp---', response.data.data[0])

            if (hostname.indexOf('local') > -1) {
              url_type = 'local'
            } else if (hostname.indexOf('dev') > -1) {
              url_type = 'dev'
            } else if (hostname.indexOf('qa') > -1) {
              url_type = 'qa'
            } else {
              url_type = 'prod'
            }

            if (typeof appUrl == 'object') {
              sso_url = appUrl[url_type]
                ? appUrl[url_type]
                : appUrl[Object.keys(appUrl)[0]]
                ? appUrl[Object.keys(appUrl)[0]]
                : appUrl
            } else {
              sso_url = appUrl
            }

            window.location = sso_url
          } else {
            saveToken(response.data.autherizationToken)
            this.props.onLoginSuccess({
              ...response.data.userDetails,
              autherizationToken: response.data.autherizationToken,
            })
          }
        })
        .catch((error) => {
          console.log('err--', error)

          if (error && error.response && error.response.data) {
            let { errors } = error.response.data

            let errorMsg =
              errors && typeof errors === 'string' ? errors : errors.message

            this.setState({
              ...this.state,
              errorMessage: errorMsg,
              submittedEmail: emailVal,
              isOptIn: true,
              alert_org_email_msg:
                errors && errors.message
                  ? errors.message
                  : 'Email does not exist in any organization',
            })
          }
        })
    }
  }

  showLoginForm = () => {
    this.setState({ isLogin: true })
  }

  goBack = () => {
    // this.props.history.push('/login')
    this.setState({ isLogin: false })
  }

  goNewUser = () => {
    this.props.history.push('/find-enterprise')
  }

  ssoSignIn = (sso_provider) => {
    let url = return_sso_url(sso_provider)
    window.location = url
  }

  showOptInScreen = () => {
    this.setState((prevState) => ({
      findOrg: !prevState.findOrg,
    }))
  }

  showSSOlogin = () => {
    this.setState((prevState) => ({
      ssoDisplay: !prevState.ssoDisplay,
      isOptIn: false,
      errorMessage: null,
    }))
  }

  onDismiss = () => {
    this.setState({ isOptIn: false, errorMessage: null })
  }

  showPasswordValue = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }))
  }

  showLoginDisplay = () => {
    let {
      ssoDisplay,
      findOrg,
      email,
      orgEmail,
      password,
      isDisabled,
      showPassword,
    } = this.state
    const fromTrivvy =
      isTrivvyProduct() || window.location.href.includes('fromTrivvy=true')
    if (ssoDisplay != true && findOrg != true) {
      return (
        <span className="form_inputs">
          <div className="group floating-label-group">
            <Input
              onChange={this.handleEmailChange}
              value={email.value}
              invalid={email.error}
              id="email"
              type="text"
              className="input"
              autoComplete="off"
              placeholder=" "
            />
            <label htmlFor="user" className="label floating-label">
              Email
            </label>
          </div>

          <div className="group floating-label-group mb0">
            <Input
              onChange={this.handlePasswordChange}
              invalid={password.error}
              value={password.value}
              autoComplete="off"
              id="pass"
              type={showPassword ? 'text' : 'password'}
              className="input"
              data-type={showPassword ? 'text' : 'password'}
              placeholder=" "
            />
            {showPassword ? (
              <BiShow
                size={'20px'}
                className="login-password-eye-icon"
                onClick={this.showPasswordValue}
              />
            ) : (
              <BiHide
                size={'20px'}
                className="login-password-eye-icon"
                onClick={this.showPasswordValue}
              />
            )}
            <label htmlFor="pass" className="label floating-label">
              Password
            </label>
          </div>

          <div className="group forget-password-link-container">
            <Link
              to={`/reset-password${fromTrivvy ? '?fromTrivvy=true' : ''}`}
              className="link-forgot-password">
              Forgot Password?
            </Link>
          </div>
          {/* disabledBtn */}

          {isDisabled ? <img src={Spinner} className="spinner-pos" /> : null}

          <div className={`group ${isDisabled ? 'disabledBtn' : ''}`}>
            <div
              className={`login-container-btn btn btn-success`}
              onClick={isDisabled ? null : this.handleSignIn}>
              Log In
            </div>
          </div>

          <p className="text-center mt-3" style={{ fontSize: '12px', color: '#6c757d' }}>
            By continuing, you agree to our{' '}
            <a href="https://www.gotrivvy.com/terms-conditions" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Terms of Use</a>
            {' '}and{' '}
            <a href="https://www.gotrivvy.com/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Privacy Policy</a>.
          </p>
        </span>
      )
    } else if (ssoDisplay) {
      return (
        <span className="form_inputs">
          <div className="group floating-label-group">
            <Input
              onChange={this.orgEmailChange}
              value={orgEmail.value}
              invalid={orgEmail.error}
              id="email"
              type="text"
              className="input"
              autoComplete="off"
              placeholder=" "
            />
            <label htmlFor="user" className="label floating-label">
              Email
            </label>
          </div>

          <div className="login_page_sso_btns">
            <span
              className="login-container-btn btnBack"
              onClick={() => this.showSSOlogin()}>
              Back
            </span>
            <div
              className="login-container-btn btn btn-success"
              onClick={() => this.handleOrgEmail('sso')}>
              Sign in with Org Email
            </div>
          </div>
        </span>
      )
    }
  }

  renderForm = (value) => {
    let {
      email,
      findOrg,
      ssoDisplay,
      orgEmail,
      isLogin,
      password,
      errorMessage,
      alert_org_email_msg,
      isOptIn,
      submittedEmail,
      isFromResetLink,
    } = this.state

    let alert = null
    if (value) {
      alert = value
    }
    if (isFromResetLink) {
      alert = (
        <div className="success-msg-bg mt50">
          <i
            className="close-icon"
            onClick={() => this.setState({ isFromResetLink: false })}>
            close
          </i>
          <div className="d-flex custom-message-box">
            <i className="material-icons success-icon-bg font18">
              check_circle
            </i>
            <span className="ml20 message-sub-text">
              Please enter the login information sent to the email account you
              provided.
            </span>
          </div>
        </div>
      )
    }
    const formMargin = isMobile ? 'mt35' : 'mt50'
    if (!findOrg) {
      return (
        <div className="login-wrap">
          <div className="login-html">
            <div
              className="login-form"
              style={{
                ...(isTrivvyProduct() &&
                  !isMobile && {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }),
              }}>
              <div className="sign-in-htm">
                {errorMessage != null ? (
                  <Alert
                    color="warning"
                    isOpen={errorMessage != null}
                    toggle={this.onDismiss}
                    className="alert-sign-in-css">
                    {errorMessage}
                  </Alert>
                ) : null}

                {this.showLoginDisplay()}

                {!isTrivvyProduct() && ssoDisplay != true ? (
                  <div className="or">
                    <span>OR</span>
                  </div>
                ) : null}

                {!isTrivvyProduct() && (
                  <div className="login-provider-img-container">
                    {ssoDisplay != true ? (
                      <span className="login_page_buttons">
                        <span
                          className="login-provider-img-item optInBtn"
                          onClick={() => this.showOptInScreen()}>
                          <span className="login-provider-img-item-txt">
                            Opt-in via your Organization
                          </span>
                        </span>

                        <span
                          className="login-provider-img-item"
                          onClick={
                            ssoDisplay
                              ? () => this.handleOrgEmail('sso')
                              : () => this.showSSOlogin()
                          }>
                          <span className="login-provider-img-item-txt">
                            {ssoDisplay != true
                              ? 'Sign in with Single Sign On (SSO)'
                              : 'Sign In with Organization Email'}
                          </span>
                          {/* <img src={oktaImg} className="login-provider-img-icon"/> */}
                        </span>
                      </span>
                    ) : null}

                    {/* <span className="login-provider-img-item" onClick={()=>this.ssoSignIn('okta')}>
						<span className="login-provider-img-item-txt">Continue with Organization Sign In</span>
						<img src={oktaImg} className="login-provider-img-icon"/>
					</span> */}
                  </div>
                )}
              </div>

              <div className="sign-up-htm">
                <div className="group floating-label-group">
                  <Input
                    autoComplete="off"
                    type="text"
                    className="input"
                    placeholder=" "
                  />
                  <label htmlFor="pass" className="label floating-label">
                    Email Address
                  </label>
                </div>

                <div className="group floating-label-group">
                  <Input
                    autoComplete="off"
                    id="pass"
                    type="password"
                    className="input"
                    data-type="password"
                    placeholder=" "
                  />
                  <label htmlFor="pass" className="label floating-label">
                    Password
                  </label>
                </div>

                <div className="group floating-label-group">
                  <Input
                    autoComplete="off"
                    id="pass"
                    type="password"
                    className="input"
                    data-type="password"
                    placeholder=" "
                  />
                  <label htmlFor="pass" className="label floating-label">
                    Repeat Password
                  </label>
                </div>

                <div className="group">
                  <input type="submit" className="button" value="Sign Up" />
                </div>

                <div className="foot-lnk">
                  <label htmlFor="tab-1">Already Member?</label>
                </div>
              </div>
            </div>
          </div>
          <img
            src={isTrivvyProduct() ? loginImgTrivvy : loginImg}
            className={`${isTrivvyProduct() ? 'login-trivvy-img-container' : 'login-img-container'}`}
          />
        </div>
      )
    } else {
      return (
        <Form className={alert == null ? 'mt50' : 'mt30'}>
          {/* organization email */}
          {isOptIn ? (
            <Alert color="warning" isOpen={isOptIn} toggle={this.onDismiss}>
              {alert_org_email_msg}
            </Alert>
          ) : null}
          <FormGroup>
            <Label htmlFor="email" className="label-login-email mb10">
              Enter your email
            </Label>
            <Input
              type="email"
              name="email"
              id="email"
              value={orgEmail.value}
              className="inputBox-height"
              tabIndex={1}
              onChange={this.orgEmailChange}
              // invalid={email.error}
            />
            <FormFeedback>Please enter your email.</FormFeedback>
          </FormGroup>

          <div className="text-center mt30 col-lg-8 login-btn-itm-css">
            <Button onClick={this.handleOrgEmail} className="btn-sign-in">
              <span className="txt-sign-in-btn">
                <span className="lock-icon">
                  <i className="material-icons md1"></i>
                </span>
                Submit
              </span>
            </Button>
          </div>

          <div
            className="col-lg-4 text-right link-forgot-password  login-btn-itm-css"
            onClick={this.findOrg}>
            Go Back
          </div>
        </Form>
      )
    }
  }

  closeInfoModal = () => {
    // saveShowInstructions(!this.state.infoModel);
    this.setState((prevState) => ({
      infoModel: !prevState.infoModel,
    }))
  }

  installationInstructions() {
    const fromTrivvy =
      isTrivvyProduct() || window.location.href.includes('fromTrivvy=true')
    if (isMobile && isSafari)
      return (
        <Modal
          className="welcomemodalparent"
          isOpen={true}
          style={{ marginTop: '80px' }}>
          <ModalBody className="installInfoModalBody">
            <button
              className="install-info-modal-close"
              onClick={this.closeInfoModal}>
              <img src={drillDownClose} height="35px" width="35px" />
            </button>
            <div className="col-sm-12 col-md-12 body-container">
              <div>
                <img
                  src={fromTrivvy ? trivvyLogo : companyLogo}
                  height="40px"
                  width="40px"
                />
                <span className="pl10">
                  <b> Install {fromTrivvy ? 'Trivvy' : 'OurOffice'} App </b>
                </span>
              </div>
              <div className="instructions-details">
                <div>
                  1- Select
                  <img
                    className="export-icon"
                    src={exportIcon}
                    height="25px"
                    width="25px"
                  />
                  from Nav Bar at the bottom of your screen
                </div>
                <br />
                <div>
                  2- Scroll to find <b>"Add to Home Screen"</b> Button
                </div>
                <br />
                <div style={{ textAlign: 'center' }}>
                  <img
                    className="instructions-image"
                    src={installInstructionsImage}
                    height="85x"
                  />
                </div>
                <br />
                <div>
                  3- Select <b>"Add"</b> or follow the instructions provided on
                  your phone to add the App icon to your Home screen.
                </div>
              </div>

              <div>
                <Button className="done-button" onClick={this.closeInfoModal}>
                  Got it !
                </Button>
              </div>
              <br />

              <div className="hint">
                <span className="hint-arrow">
                  <i className="flaticon-next"></i>
                </span>
                <span className="hint-arrow">
                  <i className="flaticon-next"></i>
                </span>
                <span className="hint-arrow">
                  <i className="flaticon-next"></i>
                </span>
              </div>
            </div>
          </ModalBody>
        </Modal>
      )
  }

  render() {
    // console.log(this.state);
    let { email, password, errorMessage, isFromResetLink, findOrg } = this.state
    let alert = null
    // console.log(isMobile, notChrome)

    const fromTrivvy =
      isTrivvyProduct() || window.location.href.includes('fromTrivvy=true')
    if (errorMessage !== null) {
      alert = (
        <div className="alert-msg-bg mt50">
          <i
            className="close-icon"
            onClick={() => {
              this.setState({ errorMessage: null })
            }}>
            close
          </i>
          <div className="d-flex custom-message-box">
            <i className="material-icons alert-icon-bg font18">remove_circle</i>
            <span className="ml20 alert-msg-text">
              {this.state.errorMessage}
              <br />
              <span className="message-sub-text">
                Please try typing in your login information again.
              </span>
            </span>
          </div>
        </div>
      )
    } else if (isFromResetLink) {
      alert = (
        <div className="success-msg-bg mt50">
          <i
            className="close-icon"
            onClick={() => this.setState({ isFromResetLink: false })}>
            close
          </i>
          <div className="d-flex custom-message-box">
            <i className="material-icons success-icon-bg font18">
              check_circle
            </i>
            <span className="ml20 message-sub-text">
              Please enter the login information sent to the email account you
              provided.
            </span>
          </div>
        </div>
      )
    } else if (!isChrome && !isMobile) {
      alert = (
        <div className="info-msg-bg mt50">
          <i
            className="close-icon"
            onClick={() => {
              this.setState({ errorMessage: null })
            }}>
            close
          </i>
          <div className="d-flex custom-message-box">
            {/* <i className="material-icons alert-icon-bg font18">remove_circle</i> */}
            <span className="ml20 alert-msg-text">
              {this.state.errorMessage}
              <span className="message-sub-text">
                OurOffice platform is optimized for the Google Chrome browser.
                If you experience any unexpected issues, please try to switch to
                Chrome. You can also contact us at{' '}
                <a href="mailto:team@ouroffice.io">team@ouroffice.io</a>.
                {/* Please switch to Google Chrome browser to avoid unexpected issues. If Chrome is not available on your system, please contact your system administrator, or let us know at team@ouroffice.io. */}
              </span>
            </span>
          </div>
        </div>
      )
    }
    return (
      <Container
        className={`login-layout-container ${
          findOrg ? 'org-form-container' : ''
        }`}>
        {this.state.infoModel && this.installationInstructions()}
        <Row className="login-outer-wrapper">
          {fromTrivvy ? (
            <div className="login-container-title-trivvy">
              {/* <img src={trivvyLogo} className="trivvy-logo-img" /> */}
              <span className="sidebar-trivvy-logo-txt-lg">Trivvy</span>
            </div>
          ) : (
            <div className="login-container-title">
              <img src={DaniLogo} className="" />
              OurOffice
            </div>
          )}

          <div className="login-form-container">
            <If condition={isMobile}>
              {!fromTrivvy && (
                <div className="text-center mt-4">
                  <img
                    style={{
                      height: '66px',
                      width: '91px',
                      marginBottom: '15px',
                      marginTop: '15px',
                    }}
                    src={DaniLogo}
                  />
                </div>
              )}
            </If>
            {/* {alert} */}
            {this.renderForm(alert, true)}
          </div>
          {/* { !isMobile && <LoginSide />} */}
        </Row>
        <Row>
          <div id="login-secondary" className="col-sm-12 mb10 pl30">
            <div className="text-center">
              © {new Date().getFullYear()}{' '}
              {fromTrivvy ? (
                <a href="https://www.gotrivvy.com/">Trivvy</a>
              ) : (
                <a href="https://www.ouroffice.io/">OurOffice, Inc</a>
              )}
            </div>
          </div>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  // console.log('State after Login', state);
  return {
    user: state.user,
    isPasswordChanged: state.user.profile.isPasswordChanged,
    isProfileDetailsUpdated: state.user.profile.isProfileDetailsUpdated,
    isAuthenticated:
      state.user.profile.autherizationToken &&
      state.user.profile.autherizationToken !== null,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onLoginSuccess: (data) => dispatch(actionCreators.loginSuccess(data)),
    onLogoutSuccess: (data) => dispatch(actionCreators.logout()),
    onFetchOfficeSuccess: (data) =>
      dispatch(actionCreators.fetchOfficeSuccess(data)),
    setCreateModalState: (data) =>
      dispatch(actionCreators.setCreateModalState(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
